__turbopack_context__.v({
  "switchButton": "_8CDJ9W_switchButton",
});
